// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-information-wrapper img {
  width: 600px;
  height: 400px;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}
.modal-information-wrapper .title {
  font-size: 18px !important;
  font-weight: bold;
  margin-bottom: var(--spacing-small) !important;
  text-align: center !important;
}
@media (max-width: 600px) {
  .modal-information-wrapper .title {
    font-size: 16px !important;
    padding: var(--spacing-small) 0 !important;
  }
}
@media (max-width: 600px) {
  .modal-information-wrapper img {
    width: 100%;
    height: auto;
  }
}
@media (min-width: 601px) and (max-width: 1024px) {
  .modal-information-wrapper img {
    width: 100%;
    height: auto;
  }
}
@media (min-width: 1025px) {
  .modal-information-wrapper img {
    width: 600px;
    height: 400px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/InformationModal/InformationModal.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AACF;AAEA;EAEI,0BAAA;EACA,iBAAA;EACA,8CAAA;EACA,6BAAA;AADJ;AAIE;EAAA;IAEI,0BAAA;IACA,0CAAA;EAFJ;AACF;AAMA;EACE;IACE,WAAA;IACA,YAAA;EAJF;AACF;AAOA;EACE;IACE,WAAA;IACA,YAAA;EALF;AACF;AAQA;EACE;IACE,YAAA;IACA,aAAA;EANF;AACF","sourcesContent":[".modal-information-wrapper img {\n  width: 600px;\n  height: 400px;\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n}\n\n.modal-information-wrapper {\n  .title {\n    font-size: 18px !important;\n    font-weight: bold;\n    margin-bottom: var(--spacing-small) !important;\n    text-align: center !important;\n  }\n\n  @media (max-width: 600px) {\n    .title {\n      font-size: 16px !important;\n      padding: var(--spacing-small) 0 !important;\n    }\n  }\n}\n\n@media (max-width: 600px) {\n  .modal-information-wrapper img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n@media (min-width: 601px) and (max-width: 1024px) {\n  .modal-information-wrapper img {\n    width: 100%;\n    height: auto;\n  }\n}\n\n@media (min-width: 1025px) {\n  .modal-information-wrapper img {\n    width: 600px;\n    height: 400px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
